<script module lang="ts">
	export enum LanguageOrientation {
		HORIZONTAL = 'horizontal',
		VERTICAL = 'vertical'
	}

	const languages = [
		{ code: 'de', label: 'Deutsch', flag: FLAG_DE },
		{ code: 'en', label: 'English', flag: FLAG_EN }
	] as const
</script>

<script lang="ts">
	import { locale } from 'svelte-i18n'
	import { FLAG_DE, FLAG_EN } from '../assets/index.js'
	import { LANGUAGE_OPTIONS } from '../utils/language.js'

	interface Props {
		languageOrientation?: LanguageOrientation
	}

	let { languageOrientation = LanguageOrientation.HORIZONTAL }: Props = $props()

	const currentLocale = $derived($locale)

	function setLocale(lang: string): void {
		$locale = lang
	}

	$effect(() => {
		const lang = $locale || 'en'

		const found = LANGUAGE_OPTIONS.find(({ id }) => id === lang) || LANGUAGE_OPTIONS[0]

		setLocale(found!.id!)
	})
</script>

<div class="language-container {languageOrientation}">
	{#each languages as { code, label, flag }}
		<button
			class="flag-button"
			onclick={() => setLocale(code)}
			class:selected={currentLocale === code}
		>
			<img src={flag} alt={label} class="flag-icon" />
		</button>
	{/each}
</div>

<style>
	.language-container {
		@apply flex items-center gap-2;
	}

	.language-container.vertical {
		@apply flex-col gap-4;
	}

	.flag-button {
		@apply cursor-pointer rounded-[4px];

		&.selected {
			@apply p-0.5 bg-[#007acc] rounded-[4px];
		}
	}

	.flag-icon {
		@apply w-6 h-4 rounded-[4px];
	}
</style>
